import { Component } from "react";

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    // Keep the console useful while the UI avoids a blank page.
    console.error("App page error", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      const message = this.state.error?.message || String(this.state.error || "Unknown display error");
      const stack = this.state.errorInfo?.componentStack || "";
      return (
        <div className="min-h-screen bg-[hsl(var(--background))] text-white p-8">
          <div className="surface p-6 max-w-3xl">
            <div className="label-eyebrow text-[hsl(var(--destructive))]">Page error</div>
            <h1 className="text-2xl font-semibold mt-2">This page hit a display error.</h1>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mt-3">
              Refresh once after the latest update. If it stays here, this message should replace the blank page and make the error easier to track.
            </p>
            <div className="mt-4 rounded border border-[hsl(var(--border))] bg-black/35 p-3 text-xs text-[hsl(var(--muted-foreground))] break-words">
              <div className="font-mono text-[#f3ead3]">{message}</div>
              {stack && <pre className="mt-3 whitespace-pre-wrap font-mono text-[10px] max-h-56 overflow-auto">{stack}</pre>}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
